<app-carrousel-one></app-carrousel-one>
<app-proposito></app-proposito>
<app-featured></app-featured>
<app-members></app-members>
<app-carrousel-two></app-carrousel-two>
<button class="d-lg-none" (click)="this.buttonClick()">
  {{ this.esSuscriptor ? "PLATAFORMA BLOCKCHAIN" : "UNITE" }}
</button>
